module.exports = __webpack_public_path__ + "static/media/pic19.ed2814ad.jpg";